import { PaymentDetailsEntry } from '../types/payment-details';
import { PaymentDetailsResponse } from '../types/response/payment-details-response';

export const mapPaymentDetailsFromResponse = (
  response: PaymentDetailsResponse
): PaymentDetailsEntry => ({
  id: response.id,
  name: response.name,
  details: response.details,
  isDefault: response.isDefault,
});

export const mapPaymentDetailsListFromResponse = (
  responses: PaymentDetailsResponse[]
): PaymentDetailsEntry[] => responses.map(mapPaymentDetailsFromResponse);
